import { render, staticRenderFns } from "./UpdateDialog.vue?vue&type=template&id=4233626d&scoped=true"
import script from "./UpdateDialog.vue?vue&type=script&lang=js"
export * from "./UpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4233626d",
  null
  
)

export default component.exports